(function () {
  const DESKTOP_HOVER_MEDIA = window.matchMedia('(min-width: 750px) and (hover: hover)');
  const FEATURE_CARD_SELECTOR = '.feature-card';

  function isInFeatureCard(img) {
    return !!img.closest(FEATURE_CARD_SELECTOR);
  }

  function isAnimatedSource(src) {
    if (!src) return false;
    const normalized = src.toLowerCase();
    return (
      normalized.includes('.gif') ||
      normalized.includes('_anim') ||
      normalized.includes('rise_pro')
    );
  }

  function getImageSrc(img) {
    return img.dataset.animatedSrc || img.currentSrc || img.src || '';
  }

  const ANIMATED_FEATURE_KEYS = new Set([
    'keyboard_tray',
    'adjustable_desktop',
    'desktop_height',
    'split_desktop',
    'rack_kit',
    'cover_panel',
  ]);

  function isAnimatedFeatureCard(img) {
    const card = img.closest('[data-feature-key]');
    if (!card) return false;
    return ANIMATED_FEATURE_KEYS.has(card.dataset.featureKey);
  }

  function shouldAnimateImage(img) {
    if (!isInFeatureCard(img)) return false;
    if (isAnimatedFeatureCard(img)) return true;
    return isAnimatedSource(getImageSrc(img));
  }

  function markAnimatedImage(img) {
    if (!shouldAnimateImage(img)) return false;
    const src = getImageSrc(img);

    img.classList.add('buso-animated-media-img');
    if (!img.dataset.animatedSrc) {
      img.dataset.animatedSrc = src;
    }
    if (!img.hasAttribute('crossorigin')) {
      img.setAttribute('crossorigin', 'anonymous');
    }
    return true;
  }

  function getAnchor(img) {
    return img.closest('.feature-card__image-wrapper') || img.parentElement;
  }

  function getHoverHost(img) {
    return img.closest(FEATURE_CARD_SELECTOR) || getAnchor(img);
  }

  function captureStaticFrame(img) {
    const width = img.naturalWidth;
    const height = img.naturalHeight;
    if (!width || !height) return null;

    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;

    const context = canvas.getContext('2d');
    if (!context) return null;

    context.drawImage(img, 0, 0, width, height);

    try {
      return canvas.toDataURL('image/jpeg', 0.92);
    } catch (error) {
      return null;
    }
  }

  function ensureIndicator(anchor) {
    let indicator = anchor.querySelector('.buso-animated-media-indicator');
    if (indicator) return indicator;

    indicator = document.createElement('span');
    indicator.className = 'buso-animated-media-indicator';
    indicator.setAttribute('aria-hidden', 'true');
    indicator.innerHTML =
      '<svg class="buso-animated-media-icon buso-animated-media-icon--play" viewBox="0 0 12 12" aria-hidden="true"><path d="M3 2.2v7.6L9.8 6 3 2.2z"/></svg>' +
      '<svg class="buso-animated-media-icon buso-animated-media-icon--pause" viewBox="0 0 12 12" aria-hidden="true"><path d="M2.4 2h2.2v8H2.4V2zm5 0h2.2v8H7.4V2z"/></svg>';
    anchor.appendChild(indicator);
    return indicator;
  }

  function setPlaying(img, isPlaying) {
    const anchor = getAnchor(img);
    if (!anchor) return;
    anchor.classList.add('buso-animated-media-anchor');
    if (!DESKTOP_HOVER_MEDIA.matches) {
      anchor.classList.remove('buso-animated-media--playing');
      return;
    }
    ensureIndicator(anchor);
    anchor.classList.toggle('buso-animated-media--playing', isPlaying);
  }

  function playImage(img) {
    if (img.dataset.animatedSrc) {
      img.src = img.dataset.animatedSrc;
    }
  }

  function freezeAnimatedImage(img) {
    if (!img.dataset.animatedSrc || img.dataset.staticReady === 'true') return;

    img.crossOrigin = img.crossOrigin || 'anonymous';

    const applyStatic = () => {
      const staticSrc = captureStaticFrame(img);
      if (!staticSrc) {
        img.classList.remove('buso-animated-media-img');
        return;
      }

      img.dataset.staticSrc = staticSrc;
      img.dataset.staticReady = 'true';
      img.src = staticSrc;
    };

    if (img.complete && img.naturalWidth) {
      applyStatic();
      return;
    }

    img.addEventListener('load', applyStatic, { once: true });
  }

  function bindHover(img) {
    if (img.dataset.busoAnimatedHoverBound === 'true') return;

    const host = getHoverHost(img);
    if (!host) return;

    img.dataset.busoAnimatedHoverBound = 'true';
    setPlaying(img, false);

    host.addEventListener('mouseenter', () => {
      playImage(img);
      setPlaying(img, true);
    });

    host.addEventListener('mouseleave', () => {
      if (img.dataset.staticSrc) {
        img.src = img.dataset.staticSrc;
      }
      setPlaying(img, false);
    });
  }

  function resetImage(img) {
    playImage(img);
    delete img.dataset.staticReady;
    delete img.dataset.staticSrc;
    delete img.dataset.busoAnimatedHoverBound;
    if (DESKTOP_HOVER_MEDIA.matches) {
      setPlaying(img, false);
    }
  }

  function resetAll() {
    document.querySelectorAll('.buso-animated-media-indicator').forEach((indicator) => {
      indicator.remove();
    });

    document.querySelectorAll('.buso-animated-media-anchor').forEach((anchor) => {
      anchor.classList.remove('buso-animated-media--playing', 'buso-animated-media-anchor');
    });

    document.querySelectorAll('.buso-animated-media-img').forEach((img) => {
      img.classList.remove('buso-animated-media-img');
      delete img.dataset.busoAnimatedHoverBound;
      delete img.dataset.staticReady;
      delete img.dataset.staticSrc;
    });
  }

  function initImage(img) {
    if (!isInFeatureCard(img) || !markAnimatedImage(img)) {
      img.classList.remove('buso-animated-media-img');
      return;
    }

    const anchor = getAnchor(img);
    if (anchor) {
      anchor.classList.add('buso-animated-media-anchor');
      if (DESKTOP_HOVER_MEDIA.matches) {
        ensureIndicator(anchor);
      }
    }

    if (!DESKTOP_HOVER_MEDIA.matches) {
      resetImage(img);
      return;
    }

    freezeAnimatedImage(img);
    bindHover(img);
  }

  function initAll(root) {
    const scope = root || document;
    scope.querySelectorAll(`${FEATURE_CARD_SELECTOR} img`).forEach(initImage);
  }

  function handleMediaChange() {
    resetAll();
    initAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  if (typeof DESKTOP_HOVER_MEDIA.addEventListener === 'function') {
    DESKTOP_HOVER_MEDIA.addEventListener('change', handleMediaChange);
  } else if (typeof DESKTOP_HOVER_MEDIA.addListener === 'function') {
    DESKTOP_HOVER_MEDIA.addListener(handleMediaChange);
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (!event.target) return;

    event.target.querySelectorAll('.buso-animated-media-indicator').forEach((indicator) => {
      indicator.remove();
    });
    event.target.querySelectorAll('.buso-animated-media-anchor').forEach((anchor) => {
      anchor.classList.remove('buso-animated-media--playing', 'buso-animated-media-anchor');
    });
    event.target.querySelectorAll('.buso-animated-media-img').forEach((img) => {
      img.classList.remove('buso-animated-media-img');
      delete img.dataset.busoAnimatedHoverBound;
      delete img.dataset.staticReady;
      delete img.dataset.staticSrc;
    });

    initAll(event.target);
  });
})();
